<script setup lang="ts">
import { ref } from "vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import { useConfirmKeys } from "@/composables/useConfirmKeys";

const props = defineProps<{
	loading?: boolean
}>()

const emit = defineEmits<{
	(e: 'cancel'): void,
	(e: 'confirm'): void,
}>()

const $root = ref<HTMLElement | null>(null)

useConfirmKeys({
	content: $root,
	cancel: () => emit('cancel'),
	confirm: () => emit('confirm'),
	disabled: () => !!props.loading,
})
</script>

<template>
	<div ref="$root" class="detach-counterparty-confirm">
		<div class="detach-counterparty-confirm__title">
			{{ $t('counterparty_detach_question') }}
		</div>
		<div class="detach-counterparty-confirm__actions">
			<app-button
				class="detach-counterparty-confirm__actions-button"
				type="secondary"
				:label="$t('cancel_short')"
				@click="emit('cancel')"
			/>
			<app-button
				class="detach-counterparty-confirm__actions-button"
				:label="$t('ui_detach')"
				:disabled="loading"
				@click="emit('confirm')"
			/>
		</div>
	</div>
</template>

<style scoped lang="scss">
.detach-counterparty-confirm {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	padding: 12px;
	gap: 8px;

	&__title {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		line-height: 18px;
		font-weight: 600;
		color: #4D4D4D;
		text-align: center;
	}

	&__actions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;

		&-button {
			flex: 1;
		}
	}
}
</style>
